export default {
domainInvalid: {
  siteUnavailableTitle: "Hindi Magamit ang Site",
  siteUnavailableDesc: "Hindi magamit ang site na ito sa kasalukuyan.",
  contactAdmin: "Mangyaring makipag-ugnayan sa administrator.",
  serverErrorTitle: "Hindi Magamit ang Serbisyo",
  serverErrorDesc: "Nabigo ang koneksyon sa server, subukang muli mamaya.",
  serverErrorTip: "Awtomatikong kokonekta muli kapag bumalik na ang server.",
  notAuthorizedTitle: "Hindi Awtorisado ang Domain",
  notAuthorizedDesc: "Ang kasalukuyang domain ay hindi awtorisado na mag-access sa serbisyong ito.",
  checking: "Sinusuri...",
  retry: "Subukang muli",
  reload: "I-reload",
  reloading: "Nirereload...",
  checkingDomain: "Sinusuri ang domain...",
  authorizedRedirecting: "Awtorisado na ang domain, nagre-redirect...",
  stillNotAuthorized: "Hindi pa rin awtorisado ang domain",
  reconnecting: "Muling kumokonekta..."
}
};
